/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-08-17 15:59:55
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-11-17 14:54:01
 * @FilePath: \sea-page-game\src\utils\sign.js
 */
import CryptoJS from "crypto-js";
import md5 from 'blueimp-md5'
import { randomStr } from "./util";
import Base from "./base";

//根据app_id的不同产生不同的game_key
// function getGamekey(app_id) {
//   var game_key;
//   // app_id == "103537" 研发测试用     app_id == "103429" 正式环境用
//   if (app_id == "103537" || app_id == "103429") {
//     game_key = "A8wObWCVLMZRdiH";
//   }
//   return game_key;
// }


/* ---------- 签名算法 ---------- */
export const RSSign = (params, app_id) => {
  let key = getGamekeyV2(app_id);
  const aString = Object.keys(params).filter(key => {
    return (key !== "sign" && key !== "sign_type" && key !== "" && key !== null && params[key] !== "");
  }).sort().reduce((prev, cur) => {
    return prev + `${cur}=${params[cur]}&`;
  }, "");
  return md5(`${aString}${key}`);
};

/* ---------- RS MD5 加密---------- */
export const RSMD5 = (str) => {
  return md5(str);
};

/* ---------- Sign v2---------- */

let GlobalKey = ''

/**
 * 不同子游戏对应加密app_key
 * @param {*} app_id 子游戏id
 */
export const getGamekeyV2 = (app_id)=>{
  let app_key = ''
  if(app_id == "103321"){
    // 印尼
    app_key  = "ut465zofev1w8tf2JvCe2ZvqhV9vyZ/6nL94FA=="
  }else if(app_id == "104293"){
    // 越南
    app_key = "g3gqanf8ho162iv6e0PIS+r0O8LsYlRh6gx3jA=="
  }else if(app_id == "103537"){
    // 研发测试
    app_key = "l06mke7mkzo6klvxiYG+fM+Vj/nEtbpqjMtMxw=="
  }else if(app_id == "103429"){
    // 泰正式
    app_key = "sp2wcxv9lw19xr0762dMPPFMHLBivHsuaLmmbA=="
  }
  return Decrypt(app_key)
}

// 密钥
export const GetEncryptionKey = (initData) => {
    const fix = 'MiHqKnXuykWYmaNP'
    const { appid, pid } = initData
    storeEncryptedKey(md5(`${fix}${appid}${pid}`))
}

// 提供获取真实密钥的方法
export const getRealKey = () => {
  if(!GlobalKey){
    const urlData = Base.parseUrl(window.location.href); // canshu
    GetEncryptionKey(urlData)
  }
  var encryptedKey = GlobalKey;
  var parts = encryptedKey.split('-'); // 假设密钥和随机数以 "-" 分隔
  var realKey = parts[1] + parts[3]; // 真实密钥位于数组的第二和第四个位置
  return realKey;
}

// 将加密后的密钥存储到本地存储
export const storeEncryptedKey = (encryptedKey) => {
    // 打散加密密钥并插入随机数
    var randNum = Math.floor(Math.random() * 10) + 1
    var scrambledKey = randomStr(randNum) + '-' + encryptedKey.slice(0, randNum) + '-' + randomStr(randNum) + '-' + encryptedKey.slice(randNum); // 组合密钥和随机数
    GlobalKey = scrambledKey
}

/**
 * AES-256-CBC对称解密
 * @param encryptData {string} 要解密的密文，Base64格式，截取前面十六位为iv，后面为真实密文
 * @returns {string} 解密后的明文
 */
export const Decrypt = (encryptData) => {
  const encryptedText = CryptoJS.enc.Base64.parse(encryptData.slice(16));
  const decryptedData = CryptoJS.AES.decrypt(
      {
          ciphertext: encryptedText,
      },
      CryptoJS.enc.Utf8.parse(getRealKey()),
      {
          iv: CryptoJS.enc.Utf8.parse(encryptData.slice(0, 16)),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
      }
  );
  return decryptedData.toString(CryptoJS.enc.Utf8);
}